export const GetDataFromSession = (key: string) => {
    return sessionStorage.getItem(key);
}

export const SetDataToSession = (key: string, value : JSON) => {
    sessionStorage.setItem(key, JSON.stringify(value));
}

export const RemoveDataFromSession = (key: string) => {
    sessionStorage.removeItem(key);
}

export const HasNoFilterAppliedBookstore = (clientApollo: any) => {
    return clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreUfFilterChecked.json.length === 0 
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreCategoryFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreProviderFilterChecked.json.length === 0 
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreStoreFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreProductFilterChecked.json.length === 0;
}

export const HasNoFilterAppliedBookstoreShare = (clientApollo: any) => {
    return (HasNoFilterAppliedBookstore(clientApollo)) 
        && (clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreEndDateFilterChecked === undefined || clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreEndDateFilterChecked.length === 0)
        && (clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreInitialDateFilterChecked === undefined || clientApollo.cache.data.data.ROOT_QUERY.FILTER_bookstoreInitialDateFilterChecked.length === 0);
}

export const HasNoFilterAppliedPublisher = (clientApollo: any) => {
    return clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherUfFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBookstoreFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherEconomicGroupFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherStampFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBookFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBisacFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherPublisherFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherAuthorFilterChecked.json.length === 0
        && clientApollo.cache.data.data.ROOT_QUERY.FILTER_publisherBisacCodeFilterChecked.json.length === 0;
}

export const HasNoFilterAppliedPublisherShare = (clientApollo: any) => {
    return HasNoFilterAppliedPublisher(clientApollo)
        && (clientApollo.cache.data.data.ROOT_QUERY.FILTER_endDateFilterChecked === undefined || clientApollo.cache.data.data.ROOT_QUERY.FILTER_endDateFilterChecked.length === 0)
        && (clientApollo.cache.data.data.ROOT_QUERY.FILTER_initialDateFilterChecked === undefined || clientApollo.cache.data.data.ROOT_QUERY.FILTER_initialDateFilterChecked === 0);
}

export const GetCacheIfExists = (key: string) => {
    const dataStr = GetDataFromSession(key);
    let dataCache : any = null;
    if(dataStr != null && dataStr !== undefined && dataStr !== "") {
        dataCache = JSON.parse(dataStr);
    }
    return dataCache;
}


// WEBPACK FOOTER //
// ./src/component/shared/cache/Cache.tsx